import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {RequestBody} from "../../entity/core/request-body";
import {TitleTemplate} from "../../entity/model/title-template";

export default class TitleTemplateAgent {

    getTitleTemplateById = async (organizationId: string, titleTemplateId: string): Promise<TitleTemplate> => {
        return API.get(awsApiName, `/organizations/${organizationId}/title-templates/${titleTemplateId}`, {});
    }

    exportTitleTemplate = async (organizationId: string, requestBody: RequestBody): Promise<TitleTemplate> => {
        return API.post(awsApiName, `/organizations/${organizationId}/title-templates`, requestBody);
    }

    importTitleTemplate = async (organizationId: string, titleId: string, requestBody: RequestBody): Promise<TitleTemplate> => {
        return API.patch(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/apply-template`, requestBody);
    }

    updateTitleTemplate = async (organizationId: string, titleTemplateId: string, requestBody: RequestBody): Promise<TitleTemplate> => {
        return await API.patch(awsApiName, `/organizations/${organizationId}/title-templates/${titleTemplateId}`, requestBody);
    }

    deleteTitleTemplate = async (organizationId: string, titleTemplateId: string): Promise<void> => {
        await API.del(awsApiName, `/organizations/${organizationId}/title-templates/${titleTemplateId}`, {});
    }

    cloneTitleTemplate = async (organizationId: string, titleTemplateId: string, requestBody: RequestBody): Promise<TitleTemplate> => {
        return API.post(awsApiName, `/organizations/${organizationId}/title-templates/${titleTemplateId}/clone`, requestBody);
    }
}
